import styled from 'styled-components/macro';

import { rem } from 'polished';
import { rgba } from 'polished';
import { applyStyleModifiers } from 'styled-components-modifiers'; 
import { Button } from '@shyft/acorns';


const TableWrap = styled.section `
  height: ${(props) => props.height || '430px'};
  position: relative;
  width: 100%;
  display: block;
  overflow-y: scroll;
`;

const WinContainerPhoneEmail = styled.span`
  top: ${(props) => props.top || '0px'};
  left: ${(props) => props.left || '120px'};
  width: ${(props) => props.width || '1200px'};
  min-height: ${(props) => props.height || '612px'};
  position: absolute;
  background-color: white; //rgba(242,242,247,255);
  box-shadow: 0 5px 10px 2px rgba(195,192,192,.5);
  z-index: 2;
  overflow: scroll;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 800px) {
    left: 50px;
    min-width: 600px;
  }
  
`;

const WinContainer = styled.span`
  top: ${(props) => props.top || '0px'};
  left: ${(props) => props.left || '120px'};
  width: ${(props) => props.width || '1200px'};
  min-height: ${(props) => props.height || '612px'};
  position: absolute;
  background-color: white; //rgba(242,242,247,255);
  box-shadow: 0 5px 10px 2px rgba(195,192,192,.5);
  z-index: 2;
  overflow: scroll;
  border-radius: 5px;

  @media (max-width: 800px) {
    left: 50px;
    min-width: 600px;
  }
  
`;

const WinContainerRight = styled.section `
  top: ${(props) => props.top || '0px'};
  //left: ${(props) => props.left || '120px'};
  right: ${(props) => props.right || '20px'};
  minWidth: ${(props) => props.width || '1200px'};
  minHeight: ${(props) => props.height || '612px'};
  position: absolute;
  background-color: white; //rgba(242,242,247,255);
  box-shadow: 0 5px 10px 2px rgba(195,192,192,.5);
  border-radius: 8px;
  z-index: 2;
  padding-right: 10px;
  //overflow: scroll;
  //border: 1px solid green;
  /*
  @media (max-width: $date-time-sm) {
    padding: 1.5rem;
  }
  */

  @media (max-width: 800px) {
    left: 50px;
    min-width: 600px;
  }
  
`;

const Overlay = styled.span`
  position: fixed;
  display: ${(props) => props.display || 'none'};
  width: 100%;
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.3);
  z-index: 1; 
  cursor: pointer; 
`;

const OverlayTransparent = styled.span`
  position: fixed; 
  display: ${(props) => props.display || 'none'};
 
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0); 
  z-index: 1; 
  cursor: pointer;
`;


export default {
  TableWrap,
  WinContainerPhoneEmail,
  WinContainer,
  WinContainerRight,
  Overlay,
  OverlayTransparent,
};
